import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {TranslateService} from '@ngx-translate/core';
import {ModalDialogDismissOption} from '@shared/confirmation-dialog/modal-dialog-dismiss-option';
import {StatusEventPageService} from '@services/pages/status-event-page/configuration/status-event-page.service';
import {StatusEventSignalEventsDetails} from '@models/machine/status-event-signal/status-event-signal-events-details';
import {StatusEventPage} from '@models/sidebar/response/status-event-page';
import {LoadingIndicatorService} from '@services/loading-indicator/loading-indicator.service';
import {NotificationService} from '@services/notification/notification.service';

@Component({
    selector: 'scitis-status-event-page-edit-configuration',
    templateUrl: './status-event-page-edit-configuration.component.html',
    styleUrls: ['./status-event-page-edit-configuration.component.scss'],
    standalone: false
})
export class StatusEventPageEditConfigurationComponent implements OnInit {
  @Input()
  public pageConfiguration: StatusEventPage = new StatusEventPage(-1, '');
  @Input()
  public machineId: string | null = null;

  public pageName: string = '';

  public pageId: number | null = null;
  public modalTitle: string = 'Edit';
  public allStatusEventSignals: StatusEventSignalEventsDetails[] = [];
  public selectedStatusEventSignals: StatusEventSignalEventsDetails[] = [];
  public isLoadingStatusEventSignals: boolean = false;

  private readonly COMPONENT_NAME: string = 'StatusEventPageEditConfigurationComponent';

  constructor(
      private activeModal: NgbActiveModal,
      private translate: TranslateService,
      private loadingIndicator: LoadingIndicatorService,
      private notification: NotificationService,
      private statusEventPageService: StatusEventPageService) {
    this.modalTitle = this.translate.instant('Edit');
  }

  ngOnInit(): void {
    this.pageName = this.pageConfiguration.name;
    this.modalTitle = this.translate.instant('Edit %page').replaceAll('%page', this.pageName.toBold());
    this.pageId = this.pageConfiguration.id;
    this.loadAllStatusEventSignals(this.machineId);
  }

  onClose(): void {
    this.activeModal.dismiss(ModalDialogDismissOption.CLOSE);
  }

  onCancel(): void {
    this.activeModal.dismiss(ModalDialogDismissOption.CANCEL);
  }

  onSavePageConfiguration() {
    if (!this.machineId || !this.pageId) {
      return;
    }
    this.activeModal.close(this.selectedStatusEventSignals);
  }

  onRemoveSignal(signalId: number | undefined) {
    if (!signalId) {
      return;
    }
    this.selectedStatusEventSignals = [...this.removedItemFromArray(signalId, this.selectedStatusEventSignals)];
  }

  onUpdateSelectedSignals($event: StatusEventSignalEventsDetails[]) {
    if (!$event) {
      return;
    }
    this.selectedStatusEventSignals = [...$event];
  }


  private loadAllStatusEventSignals(machineId: string | null) {
    if (!machineId) {
      return;
    }
    this.isLoadingStatusEventSignals = true;
    this.loadingIndicator.show();

    this.statusEventPageService.listStatusEventSignals(machineId).subscribe((signals) => {
      this.allStatusEventSignals = signals;

      this.setSelectedStatusEventSignals(this.pageConfiguration, signals);
      this.loadingIndicator.hide();
      this.isLoadingStatusEventSignals = false;
    }, (error) => {
      const message = this.translate.instant('There was an error loading event status signals of parent machine');
      this.notification.error(message, error, this.COMPONENT_NAME, true);
      this.loadingIndicator.hide();
      this.isLoadingStatusEventSignals = false;
    });

  }

  private setSelectedStatusEventSignals(page: StatusEventPage, signals: StatusEventSignalEventsDetails[]) {
    let result: StatusEventSignalEventsDetails[] = [];
    if (!page.signals || page.signals.length === 0) {
      page.signals = [];
      this.selectedStatusEventSignals = [...result];
      return;
    }

    let statusEventSignalEventsDetails = Array.from(Object.values(page.statusEventsDetails));

    if (!statusEventSignalEventsDetails || statusEventSignalEventsDetails.length === 0) {
      statusEventSignalEventsDetails = Array.from(page.statusEventsDetails.values());
    }
    for (const signal of signals) {
      if (statusEventSignalEventsDetails.find(s => s.name.toLowerCase() === signal.name.toLowerCase()) && !this.selectedStatusEventSignals.find(s => s.name.toLowerCase() === signal.name.toLowerCase())) {
        result = [...result, signal];
      }
    }
    this.selectedStatusEventSignals = [...result];
  }

  private removedItemFromArray(itemId: number, array: StatusEventSignalEventsDetails[]): StatusEventSignalEventsDetails[] {
    const indexOfObject = array.findIndex((object) => {
      return object.id === itemId;
    });
    if (indexOfObject < 0) {
      return array;
    }
    array.splice(indexOfObject, 1);
    return array;

  }

}